// extracted by mini-css-extract-plugin
export default {"wrap":"modal_wrap__wvczT","modal":"modal_modal__0XY36","content":"modal_content__6Fwac","close":"modal_close__xJ7Bc"};